export const translations = {
  en: {
    nav: {
      what: "What We Do",
      platforms: "Platforms",
      cx: "Approach",
      impact: "Impact",
      founder: "Founder",
      contact: "Contact",
      cta: "Partner With Us",
    },
    hero: {
      eyebrow: "Innovation Supplier · Venture Studio · Riyadh, KSA",
      title_a: "We innovate to improve",
      title_b: "the customer experience.",
      sub: "Polestar Innovation Solutions is a Riyadh-based venture studio designing, building, and launching smart digital platforms that make every interaction sharper, faster, and more human.",
      cta_primary: "Explore Our Platforms",
      cta_secondary: "Partner With Us",
      badge_a: "Vision 2030 Aligned",
      badge_b: "6 Live Ventures",
      badge_c: "Innovation Supplier",
    },
    what: {
      eyebrow: "What We Do",
      title: "An innovation supplier, not a consultancy.",
      sub: "We ship real products. Each engagement moves through four disciplines, executed by a single accountable team.",
      cards: [
        { title: "Innovate", body: "We translate research, data and human insight into fresh product concepts with a clear commercial hypothesis." },
        { title: "Build", body: "Cross-functional squads engineer smart platforms across AI, blockchain, cloud, and modern UX with production-grade quality." },
        { title: "Launch", body: "We take products to market with go-to-market design, partnership orchestration, and precision growth loops." },
        { title: "Scale", body: "We operate what we ship: instrumented growth, iteration cycles, and long-term stewardship of the venture." },
      ],
    },
    platforms: {
      eyebrow: "Our Platforms",
      title: "Six ventures. One studio.",
      sub: "Polestar operates a portfolio of category-defining platforms across digital assets, creator economy, agriculture, smart cities, pest-controlled public spaces, and cloud-native environmental intelligence.",
      learn: "Learn more",
      items: [
        {
          key: "chaintwin",
          name: "ChainTwin",
          tag: "Flagship · Digital Twin × Blockchain",
          desc: "A digital twin and provenance platform combining IoT, blockchain, and real-time simulation to give physical assets a trusted digital identity.",
        },
        {
          key: "mashhoor",
          name: "Mashhoor",
          tag: "Creator & Influence Economy",
          desc: "A social media marketing intelligence platform connecting brands with the region's creators, powered by AI-driven matching and campaign analytics.",
        },
        {
          key: "agriai",
          name: "Agri AI",
          tag: "AI for Agriculture",
          desc: "Precision-agriculture intelligence using computer vision, sensor fusion and predictive models to optimise yield, water, and food security.",
        },
        {
          key: "urbanai",
          name: "Urban AI",
          tag: "AI for Smart Cities",
          desc: "Urban intelligence for public and private operators: mobility, energy, safety and citizen experience unified in a single decision layer.",
        },
        {
          key: "pestai",
          name: "PestTwin AI",
          tag: "Digital Twin · Parks & Cities",
          desc: "AI-powered pest-control digital twin for parks and urban environments. Sensor networks, computer vision and predictive models detect, forecast and neutralise pest hotspots before they escalate.",
        },
        {
          key: "hydration",
          name: "Hydration",
          tag: "AI Integration · Cloud · Environment",
          desc: "A cloud-native AI integration platform for environmental improvement and public-space hydration. Real-time air quality, misting, water and biodiversity intelligence orchestrated across public and private operators.",
        },
      ],
    },
    cx: {
      eyebrow: "How We Improve Customer Experience",
      title: "Design, data, and intelligence in service of the customer.",
      sub: "Every platform we ship is engineered around a simple question: does this make the customer's life measurably better?",
      pillars: [
        { title: "Human-Centred UX", body: "Interfaces designed with clarity and empathy, tested with real users before a single line ships." },
        { title: "Applied AI", body: "Machine learning where it matters: personalisation, prediction, and automation that removes friction." },
        { title: "Data-Driven Design", body: "Every screen instrumented, every hypothesis measurable, every iteration earned." },
        { title: "Automation & Orchestration", body: "Back-of-house workflows automated so the front-of-house feels effortless." },
      ],
    },
    impact: {
      eyebrow: "Why PIS",
      title: "Built for impact. Aligned with Vision 2030.",
      sub: "Numbers we care about. Measured, honest, and growing.",
      stats: [
        { value: 6, suffix: "", label: "Innovation Platforms" },
        { value: 12, suffix: "+", label: "Ventures in Portfolio" },
        { value: 3, suffix: "", label: "Markets Served" },
        { value: 2030, suffix: "", label: "Vision Aligned" },
      ],
      note: "Polestar contributes directly to KSA's Vision 2030 pillars: a diversified economy, a vibrant digital society, and an ambitious innovation ecosystem.",
    },
    founder: {
      eyebrow: "Leadership",
      title: "The vision behind Polestar.",
      name: "Mohamed Ibrahim Abutaleb Ismail",
      role: "Founder & Chief Innovation Officer",
      bio: "A serial builder with two decades across enterprise strategy, product, and venture creation, Mohamed founded Polestar to close the gap between ambitious ideas and the smart platforms that actually deliver them. He leads the studio's six ventures and its partnerships across the Gulf.",
      cta: "Read leadership note",
    },
    contact: {
      eyebrow: "Partner With Us",
      title: "Let's build the next venture together.",
      sub: "Whether you're an enterprise looking for an innovation partner, a government entity building a national platform, or an operator with a category to unlock, we'd like to hear from you.",
      form: {
        name: "Full name",
        email: "Work email",
        company: "Company (optional)",
        message: "Tell us about the venture you have in mind",
        submit: "Send Message",
        sending: "Sending…",
        success: "Message received. Our team will be in touch shortly.",
        error: "Something went wrong. Please try again.",
      },
      info: {
        email_label: "Email",
        email: "info@polestarb2b.com",
        location_label: "Studio",
        location: "Riyadh, Saudi Arabia",
        hours_label: "Response",
        hours: "Within 2 business days",
      },
    },
    footer: {
      tagline: "Innovation supplier. Venture studio. Built in Riyadh.",
      quick: "Navigate",
      ventures: "Ventures",
      contact_h: "Contact",
      rights: "© Polestar Innovation Solutions. All rights reserved.",
    },
  },
  ar: {
    nav: {
      what: "ما نقدمه",
      platforms: "منصاتنا",
      cx: "منهجيتنا",
      impact: "الأثر",
      founder: "المؤسس",
      contact: "تواصل",
      cta: "اشترك معنا",
    },
    hero: {
      eyebrow: "مورد ابتكار · استوديو مشاريع · الرياض، المملكة العربية السعودية",
      title_a: "نبتكر لنرتقي",
      title_b: "بتجربة العميل.",
      sub: "بولستار للحلول الابتكارية استوديو مشاريع مقره الرياض، يصمم ويبني ويطلق منصات رقمية ذكية تجعل كل تفاعل أكثر سلاسة وسرعة وإنسانية.",
      cta_primary: "اكتشف منصاتنا",
      cta_secondary: "اشترك معنا",
      badge_a: "متوافق مع رؤية 2030",
      badge_b: "٦ مشاريع فاعلة",
      badge_c: "مورد ابتكار",
    },
    what: {
      eyebrow: "ما نقدمه",
      title: "مورد ابتكار، لا شركة استشارات.",
      sub: "نطلق منتجات حقيقية. يمر كل تعاون بأربع مراحل ينفذها فريق واحد مسؤول من البداية إلى النهاية.",
      cards: [
        { title: "نبتكر", body: "نحول البحث والبيانات والرؤى الإنسانية إلى مفاهيم منتج جديدة ذات فرضية تجارية واضحة." },
        { title: "نبني", body: "فرق متعددة التخصصات تبني منصات ذكية في الذكاء الاصطناعي والبلوكشين والسحابة وتجربة الاستخدام الحديثة بجودة إنتاجية." },
        { title: "نطلق", body: "نأخذ المنتجات إلى السوق عبر تصميم استراتيجيات النمو، وبناء الشراكات، وتفعيل حلقات النمو الدقيقة." },
        { title: "نتوسع", body: "نشغّل ما نبنيه: نمو مقاس، دورات تكرار، ورعاية طويلة الأمد للمشروع." },
      ],
    },
    platforms: {
      eyebrow: "منصاتنا",
      title: "ستة مشاريع. استوديو واحد.",
      sub: "تدير بولستار محفظة من المنصات الرائدة في الأصول الرقمية، واقتصاد صناع المحتوى، والزراعة، والمدن الذكية، ومكافحة الآفات في الحدائق والمدن، والذكاء البيئي السحابي.",
      learn: "اعرف المزيد",
      items: [
        {
          key: "chaintwin",
          name: "تشين توين",
          tag: "المنصة الرئيسية · التوأم الرقمي × بلوكشين",
          desc: "منصة توأم رقمي وإثبات مصدر تجمع بين إنترنت الأشياء والبلوكشين والمحاكاة الفورية لمنح الأصول المادية هوية رقمية موثوقة.",
        },
        {
          key: "mashhoor",
          name: "مشهور",
          tag: "اقتصاد صناع المحتوى والتأثير",
          desc: "منصة ذكاء تسويقي لوسائل التواصل الاجتماعي تربط العلامات التجارية بصناع المحتوى في المنطقة عبر مطابقة مدعومة بالذكاء الاصطناعي وتحليلات حملات دقيقة.",
        },
        {
          key: "agriai",
          name: "أجري إيه آي",
          tag: "الذكاء الاصطناعي للزراعة",
          desc: "ذكاء زراعي دقيق يستخدم الرؤية الحاسوبية ودمج المستشعرات والنماذج التنبؤية لتحسين الإنتاج والمياه والأمن الغذائي.",
        },
        {
          key: "urbanai",
          name: "أوربان إيه آي",
          tag: "الذكاء الاصطناعي للمدن الذكية",
          desc: "ذكاء حضري للمشغلين العامين والخاصين: تنقل، طاقة، سلامة، وتجربة مواطن في طبقة قرار موحدة.",
        },
        {
          key: "pestai",
          name: "بيست توين إيه آي",
          tag: "توأم رقمي · الحدائق والمدن",
          desc: "توأم رقمي لمكافحة الآفات مدعوم بالذكاء الاصطناعي للحدائق والبيئات الحضرية. شبكات مستشعرات، رؤية حاسوبية ونماذج تنبؤية ترصد وتتوقع وتعالج بؤر الآفات قبل تفاقمها.",
        },
        {
          key: "hydration",
          name: "هايدريشن",
          tag: "تكامل ذكاء اصطناعي · سحابة · بيئة",
          desc: "منصة تكامل ذكاء اصطناعي سحابية لتحسين البيئة وترطيب الفضاءات العامة. ذكاء لحظي لجودة الهواء، والرذاذ، والمياه، والتنوع الحيوي، مُنسَّق بين المشغلين العامين والخاصين.",
        },
      ],
    },
    cx: {
      eyebrow: "كيف نرتقي بتجربة العميل",
      title: "التصميم والبيانات والذكاء في خدمة العميل.",
      sub: "كل منصة نبنيها تُصمم حول سؤال واحد: هل تجعل حياة العميل أفضل بشكل ملموس؟",
      pillars: [
        { title: "تجربة إنسانية", body: "واجهات مصممة بوضوح وتعاطف، تُختبر مع مستخدمين حقيقيين قبل أن نكتب سطراً واحداً." },
        { title: "ذكاء اصطناعي تطبيقي", body: "تعلم آلي حيث يهم: تخصيص، وتنبؤ، وأتمتة تُزيل الاحتكاك." },
        { title: "تصميم مقاد بالبيانات", body: "كل شاشة مقاسة، كل فرضية قابلة للقياس، كل تحسين مستحق." },
        { title: "أتمتة وتنسيق", body: "أتمتة العمليات الخلفية لتصبح الواجهة الأمامية بلا عناء." },
      ],
    },
    impact: {
      eyebrow: "لماذا بولستار",
      title: "مبنية للأثر. متوافقة مع رؤية 2030.",
      sub: "أرقام تهمنا. مقاسة، صادقة، ومتنامية.",
      stats: [
        { value: 6, suffix: "", label: "منصات ابتكار" },
        { value: 12, suffix: "+", label: "مشروع في المحفظة" },
        { value: 3, suffix: "", label: "أسواق نخدمها" },
        { value: 2030, suffix: "", label: "متوافق مع الرؤية" },
      ],
      note: "تساهم بولستار مباشرة في ركائز رؤية المملكة 2030: اقتصاد متنوع، مجتمع رقمي حيوي، ومنظومة ابتكار طموحة.",
    },
    founder: {
      eyebrow: "القيادة",
      title: "الرؤية خلف بولستار.",
      name: "محمد إبراهيم أبو طالب إسماعيل",
      role: "المؤسس والرئيس التنفيذي للابتكار",
      bio: "بانٍ متسلسل بخبرة عقدين في استراتيجية المؤسسات والمنتجات وريادة الأعمال، أسس محمد بولستار لسد الفجوة بين الأفكار الطموحة والمنصات الذكية التي تحققها فعلاً. يقود الاستوديو ومشاريعه الستة وشراكاته عبر منطقة الخليج.",
      cta: "اقرأ رسالة القيادة",
    },
    contact: {
      eyebrow: "اشترك معنا",
      title: "لنبنِ المشروع القادم معاً.",
      sub: "سواء كنت مؤسسة تبحث عن شريك ابتكار، أو جهة حكومية تبني منصة وطنية، أو مشغلاً يرى فئة قابلة للتحرير، نودّ سماعك.",
      form: {
        name: "الاسم الكامل",
        email: "البريد المهني",
        company: "الشركة (اختياري)",
        message: "أخبرنا عن المشروع الذي تفكر به",
        submit: "أرسل الرسالة",
        sending: "جارٍ الإرسال…",
        success: "تم استلام رسالتك. سيتواصل فريقنا معك قريباً.",
        error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      },
      info: {
        email_label: "البريد",
        email: "info@polestarb2b.com",
        location_label: "الاستوديو",
        location: "الرياض، المملكة العربية السعودية",
        hours_label: "الرد",
        hours: "خلال يومي عمل",
      },
    },
    footer: {
      tagline: "مورد ابتكار. استوديو مشاريع. مبني في الرياض.",
      quick: "روابط",
      ventures: "المشاريع",
      contact_h: "تواصل",
      rights: "© بولستار للحلول الابتكارية. جميع الحقوق محفوظة.",
    },
  },
};
